import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './TrackerDetail.module.scss';

/**
 * Status banner for terminal/archived statuses.
 * Ported from Mobile-Web OpportunityDetails.renderStatus().
 * All strings localised via react-i18next.
 */
const getStatusBanners = (t) => ({
  offer: {
    title: t('tracker.statusOffer', 'Offer'),
    color: '#F9B74E',
    getDescription: (direction) =>
      direction === 'my'
        ? t('tracker.offerDescMy', 'Congratulations, an offer is coming your way!')
        : t('tracker.offerDescTheir', 'The candidate has received an offer!'),
  },
  hired: {
    title: `✓ ${t('tracker.statusHired', 'Hired')}`,
    color: '#64CE92',
    getDescription: (direction) =>
      direction === 'my'
        ? t('tracker.hiredDescMy', 'Congratulations, you have been hired!')
        : t('tracker.hiredDescTheir', 'The candidate has been hired!'),
  },
  hired_and_archived: {
    title: `✓ ${t('tracker.statusHired', 'Hired')}`,
    color: '#64CE92',
    getDescription: (direction) =>
      direction === 'my'
        ? t('tracker.hiredDescMy', 'Congratulations, you have been hired!')
        : t('tracker.hiredDescTheir', 'The candidate has been hired!'),
  },
  passed: {
    title: t('tracker.statusPassed', 'Passed'),
    color: '#8a8a8a',
    getDescription: () =>
      t('tracker.passedDesc', 'The employer has decided to pass on this candidate.'),
  },
  declined: {
    title: t('tracker.statusDeclined', 'Declined'),
    color: '#8a8a8a',
    getDescription: (direction) =>
      direction === 'my'
        ? t('tracker.declinedDescMy', 'You have declined this job opportunity.')
        : t('tracker.declinedDescTheir', 'The candidate has declined this job.'),
  },
  expired: {
    title: t('tracker.statusExpired', 'Expired'),
    color: '#8a8a8a',
    getDescription: () =>
      t('tracker.expiredDesc', 'This referral has expired.'),
  },
  not_your_refer: {
    title: t('tracker.statusReferralDeclined', 'Referral Declined'),
    color: '#8a8a8a',
    getDescription: () =>
      t('tracker.notYourReferDesc', 'Unfortunately the user has chosen another referral provider.'),
  },
  archived: {
    title: `✗ ${t('tracker.statusRejected', 'Rejected')}`,
    color: '#E85050',
    getDescription: () =>
      t('tracker.rejectedDesc', 'The employer has rejected this candidate.'),
  },
});

const StatusBanner = ({ status, direction, referralName }) => {
  const { t } = useTranslation('common');
  const banners = useMemo(() => getStatusBanners(t), [t]);
  const config = banners[status];

  if (!config) return null;

  return (
    <div
      className={styles.statusBanner}
      style={{ backgroundColor: `${config.color}15`, borderLeft: `4px solid ${config.color}` }}
    >
      <span className={styles.statusBannerTitle} style={{ color: config.color }}>
        {config.title}
      </span>
      <span className={styles.statusBannerDesc}>{config.getDescription(direction)}</span>
    </div>
  );
};

export default StatusBanner;
